import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const MapParentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
  position: relative;
  z-index: 1;
`;

export const AddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.913)}`};
  padding: ${() =>
    `${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)} 
     ${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)}`};
`;

export const PartnersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0)}`};
  padding: ${() =>
    `${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)} 
     ${viewSizeCalculator(0)} ${viewSizeCalculator(0.75)}`};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1.5)}`};
`;

export const Title = styled.span`
  font-family: Inter;
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(0.913)}`};
  line-height: ${() => `${viewSizeCalculator(1)}`};
  color: #333333;
`;

export const AnchorWrapper = styled.div`
  display: inline-block;
  max-width: ${() => `${viewSizeCalculator(18.75)}`};
  width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PartnerTitle = styled(Title)`
  margin-bottom: ${() => `${viewSizeCalculator(1)}`};
`;

export const Value = styled.span`
  font-family: Inter;
  font-weight: 400;
  font-size: ${() => `${viewSizeCalculator(0.913)}`};
  line-height: ${() => `${viewSizeCalculator(1)}`};
  color: #333333;
  text-transform: capitalize;
  width: 85%;
`;

export const ValueBold = styled(Value)`
  font-weight: 500;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  gap: ${() => `${viewSizeCalculator(1)}`};
  align-items: center;

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }

  img {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const Partner = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${() => `${viewSizeCalculator(0)} ${viewSizeCalculator(0.625)}
                      ${viewSizeCalculator(0.75)} ${viewSizeCalculator(0.625)}`};
  border-bottom: ${() => `${viewSizeCalculator(0.0625)} solid #3333331a`};
  &:last-child {
    border-bottom: none;
  }
`;

export const PopupFooter = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ViewAllButtonWrapper = styled.span`
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.125)}`};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ViewAllContent = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.725)}`};
  font-weight: 600;
  line-height: ${() => `${viewSizeCalculator(0.75)}`};
  opacity: 30%;
  color: #333;
`;

export const PlayButtonWrapper = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: ${() => `${viewSizeCalculator(-0.3125)}`};
    width: ${() => `${viewSizeCalculator(0.625)}`};
    height: ${() => `${viewSizeCalculator(0.625)}`};
  }
`;

export const MapPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${() => `${viewSizeCalculator(15.375)}`};
  border-radius: ${() => `${viewSizeCalculator(0.75)}`};
  background-color: #f2f2f2;
`;